// extracted by mini-css-extract-plugin
module.exports = {"timePreview":"DurationPreview_timePreview__25h6X","seconds":"DurationPreview_seconds__1S36l"};